module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": "http://ohusmobs2.bkt.clouddn.com/20170616149758498873692.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_vm._v("©"), _c('a', {
    attrs: {
      "src": "https://github.com/ericjjj"
    }
  }, [_vm._v("Eric  ")]), _c('a', {
    attrs: {
      "src": "https://github.com/gpkeditor/gpkeditor"
    }
  }, [_vm._v("Github")]), _vm._v(" ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ea470990!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 18
// module chunks = 1